import React, { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AssetManagementPresenter from "./components/AssetManagementPresenter";
import { useAssetManagement } from "./hooks/useAssetManagement";
import { useAssetReport } from "./hooks/useAssetReport";

const AssetManagementPage = ({ isMobile }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const assetManagement = useAssetManagement();
  const assetReport = useAssetReport({
    fromDate: assetManagement.appliedFromDate,
    toDate: assetManagement.appliedToDate,
  });

  const handleSelectAsset = useCallback(
    (asset) => {
      if (!asset?._id) return;
      navigate(`/quan-ly-ho-so/ho-so/${asset._id}?from=asset`, {
        state: { assetReturnSearch: location.search },
      });
    },
    [location.search, navigate],
  );

  return (
    <AssetManagementPresenter
      {...assetManagement}
      isMobile={isMobile}
      onBack={() => navigate(-1)}
      onItemsPerPageChange={assetManagement.handleItemsPerPageChange}
      onExportPdf={assetManagement.handleExportPdf}
      onPageChange={assetManagement.handlePageChange}
      onRetry={assetManagement.fetchAssets}
      onSearch={assetManagement.handleSearch}
      report={{
        ...assetReport,
        onRetry: assetReport.fetchReport,
      }}
      onSelectAsset={handleSelectAsset}
    />
  );
};

export default AssetManagementPage;
